import { FormInstance } from 'antd';
import { pick } from 'lodash';
import { formatHTSNumber } from '../format';
import { NamePath } from '@xbcb/ui-types';
import { tariffKey } from './namePaths';
import {
  getTariffsWithDefinedHts,
  TariffWithHtsNumber,
} from './getTariffsWithDefinedHts';

export const addAdditionalTariffs = async (
  tariff: TariffWithHtsNumber[],
  form: FormInstance,
  fullNamePath: NamePath,
): Promise<void> => {
  const { getFieldValue, setFields } = form;

  const existingTariffs = getFieldValue([...fullNamePath, 'tariffs']);
  const payload = getTariffsWithDefinedHts([...tariff, ...existingTariffs]).map(
    (currTariff, index) => ({
      name: tariffKey(index, fullNamePath),
      value: {
        htsNumber: formatHTSNumber(
          currTariff.htsNumber ?? currTariff.number ?? currTariff.hts?.number,
        ),
        ...pick(currTariff, [
          'unitReportingQuantities',
          'unitValue',
          'pga',
          'extraPgaFlags',
        ]),
      },
    }),
  );
  if (payload.length) {
    setFields(payload);
  }
};
